const delayVideoLoad = [
    {
        selector: '[data-video=delay-load]',
        path: { filename: 'delayVideoLoad' },
    },
];

export { delayVideoLoad };
